import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Button, Separator } from 'telia-front-react';
import RoamingStore from '../../stores/RoamingStore';
import { BerecCategories } from '../RoamingInterfaces';

interface ShowMoreButtonProps {
  category: BerecCategories;
  roamingStore?: RoamingStore;
}

const ShowMoreButton = (props: ShowMoreButtonProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const {
    category,
    roamingStore: { selectedCountry, getNumberOfMoreBerecNumberResults, showMoreBerecNumberResults }
  } = props;
  const noOfMoreResults: number = getNumberOfMoreBerecNumberResults(category);

  if (isNaN(noOfMoreResults) || noOfMoreResults < 1) {
    return <Separator spacing="xxsmall" weight="thin" />;
  }
  return (
    <>
      <Separator spacing="xxsmall" weight="thin" className="hidden-md hidden-lg hidden-xl" />
      <Separator spacing="small" color="invisible" />
      <AnalyticsTrigger trigger={{ id: `Riik - ${selectedCountry.isoCode} - Berec - ${category} - Button - Vaatan rohkem`, callback: 'onClick' }}>
        <Button
          size="small"
          text={`${translate('roaming.specialInformation.showMore')} (+${noOfMoreResults})`}
          onClick={() => showMoreBerecNumberResults(category)}
        />
      </AnalyticsTrigger>
    </>
  );
};

export default inject('roamingStore')(observer(ShowMoreButton));
